import { apiClient } from '../index';

// API 응답 타입
interface ApiResponse<T> {
  code: number;
  status: string;
  message: string;
  data: T;
}

// 강의 카테고리 아이템
export interface LectureCategory {
  id: number;
  name: string;
  route_name: string;
  level: number;
  optimized_url: string;
  order: number;
  icon_image_url: string;
  lecture_count: number;
  parent_category_name: string;
  parent_category_id: number;
}

// 강의 카테고리 목록 응답
export interface LectureCategoryListResponse {
  code: number;
  status: string;
  message: string;
  data: LectureCategory[];
}

// 강의 카테고리 API
export const lectureCategoryApi = {
  // 강의 카테고리 목록 조회
  getLectureCategories: async (): Promise<LectureCategoryListResponse> => {
    try {
      const { data } = await apiClient.get<ApiResponse<LectureCategory[]>>(
        '/api/admin/lecture-categories/list',
        { withCredentials: true }
      );

      return {
        code: data.code,
        status: data.status,
        message: data.message,
        data: data.data
      };
    } catch (error: any) {
      /// console.error('Error fetching lecture categories:', error);
      throw new Error(error.response?.data?.message || '강의 카테고리 목록을 불러오는데 실패했습니다.');
    }
  }
};
